module.exports = __webpack_public_path__ + "Roboto-Thin.7500519de3d82e33d158.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Thin.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Thin.woff
// module chunks = 29